export const DISMISSED_FG_BANNERS_COOKIE = 'dismissed_fg_banners';

export const ELITE_SPOTS = 5;
export const ELITE_SPOTS_TEXT = 'five';
export const ELITE_TIPPED_SPOTS_TEXT = 'four';



// WEBPACK FOOTER //
// ./project/constants.js